export default __webpack_public_path__ + "static/media/video-call-close.24cd8695.svg";